export default __webpack_public_path__ + "static/media/bg_merchandising.1b4c0787.svg";